var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-8"},[_vm._v("\n            "+_vm._s(_vm.dataMap)+"\n        ")]),_vm._v(" "),_c('div',{staticClass:"col-sm-4"},[_c('natural-filter-language',{on:{"getDataMap":_vm.getDataMap}})],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7b19391d","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/NaturalLanguageFilterPage.vue
// module id = null
// module chunks = 